// extracted by mini-css-extract-plugin
module.exports = {"imageHover":"productCardImageScale_imageHover__dazhL"};